import { Modal } from "antd";
import React from "react";

import { formatCurrency } from "../../../../utils/formatCurrency";
import { TituloModal } from "../../../../components/tituloModal/TituloModal";
import styles from "./ContenidoModal.module.css";

export const ContenidoModal = ({ setOpen, open, desglose }) => {
  const total = desglose.reduce(
    (acc, item) => acc + (item.cantidad ?? 1) * item.costo,
    0
  );

  return (
    <Modal
      className={styles.modal}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      title={<TituloModal titulo="DATOS PRESUPUESTADOS" />}
    >
      <div className={styles.sectionTitle}>Costos</div>
      {desglose.map((item) => (
        <div key={item.id} className={styles.itemCost}>
          <div>
            <p className={styles.itemTitle}>{item.tipoCosto}</p>
            <span className={styles.itemMeta}>Cantidad: {item.cantidad ?? 1}</span>
          </div>
          <p className={styles.itemAmount}>
            {item.cantidad ?? 1} x {formatCurrency(item.costo)} = {formatCurrency((item.cantidad ?? 1) * item.costo)}
          </p>
        </div>
      ))}
      <div className={styles.totalSummary}>
        <span>Total</span>
        <strong>{formatCurrency(total)}</strong>
      </div>
    </Modal>
  );
};
